import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

/**
 * Informational banner to display in the analysis generation modal for Process Development studies.
 */
export default function ProcessDevelopmentAnalysisModalBanner(): JSX.Element {
  return (
    <div className={css(styles.banner)}>
      <InlineBanner
        bannerType={InlineBannerType.INFO}
        text="Upon creation, four types of datasets will be automatically generated based on your parameters, conditions, registered entities, and results."
      />
    </div>
  );
}

const styles = StyleSheet.create({
  banner: {
    paddingBottom: '10px',
  },
});
